import api from "../../../lib/axios";
import { apiUtils } from "../../../utils/apiUtils";
import type {
  MerchantCategory,
  MerchantCategoryListResponse,
  MerchantCategoryParentOptionListResponse,
  MerchantCategoryPayload,
  ReorderMerchantCategoriesRequest,
  ReorderMerchantCategoriesResponse,
} from "../types/merchantCategory.types";

const endpoint = "/v1/portal/merchant-categories";

export function getMerchantCategories(params: {
  page: number;
  page_size: number;
  keyword?: string;
}) {
  return apiUtils.getData<MerchantCategoryListResponse>(
    endpoint,
    "Failed to load merchant categories",
    {
      params,
    },
  );
}

export function getMerchantCategoryParentOptions(
  params: {
    keyword?: string;
    exclude_id?: string;
    page: number;
    page_size: number;
  },
  signal?: AbortSignal,
) {
  return apiUtils.getData<MerchantCategoryParentOptionListResponse>(
    `${endpoint}/parent-options`,
    "Failed to load parent merchant categories",
    { params, signal },
  );
}

function buildMerchantCategoryFormData(payload: MerchantCategoryPayload) {
  const formData = new FormData();
  if (payload.identifier) formData.append("identifier", payload.identifier);
  formData.append("description", payload.description);
  if (payload.parent_merchant_category_id) {
    formData.append("parent_merchant_category_id", payload.parent_merchant_category_id);
  }
  if (payload.icon_file) formData.append("icon_file", payload.icon_file);
  if (payload.icon_hover_file) formData.append("icon_hover_file", payload.icon_hover_file);
  return formData;
}

export async function createMerchantCategory(payload: MerchantCategoryPayload) {
  return apiUtils.unwrap(
    await apiUtils.postWithFormData<MerchantCategory>(
      endpoint,
      buildMerchantCategoryFormData(payload),
    ),
    "Failed to create merchant category",
  );
}

export async function updateMerchantCategory(id: string, payload: MerchantCategoryPayload) {
  return apiUtils.unwrap(
    await apiUtils.patchWithFormData<MerchantCategory>(
      `${endpoint}/${id}`,
      buildMerchantCategoryFormData(payload),
    ),
    "Failed to update merchant category",
  );
}

export function reorderMerchantCategories(orderedIds: string[]) {
  return apiUtils.patchData<ReorderMerchantCategoriesResponse, ReorderMerchantCategoriesRequest>(
    `${endpoint}/reorder`,
    { ordered_ids: orderedIds },
    "Failed to reorder merchant categories",
  );
}

export async function deleteMerchantCategory(id: string) {
  await api.delete(`${endpoint}/${id}`);
}
